import { useAppContext } from '../../appProvider/contextProvider';

const PaymentFailed= () => { 

    const { refetchProfile, 
        isPaymentFailure,
        setPaymentFailure, 
        isCardFailure,
        refetchFeatures,
        setCardFailure, 
        isUpdatePlanFailure, 
        setUpdatePlanFailure,
        isCancelPlanFailure,
        setCancelPlanFailure
    } = useAppContext();

    const onOk = () => {
        refetchProfile();
        refetchFeatures();
        setCardFailure(false);
        setPaymentFailure(false);
        setUpdatePlanFailure(false);
        setCancelPlanFailure(false);
    }

    const getFailedsMessage = () => {
        if(isPaymentFailure) {
            return 'Payment Failed';
        } else if(isCardFailure) {
            return 'Your card details updating has failed, Please try again later!';
        } else if(isUpdatePlanFailure) {
            return 'Your plan updating has failed, Please contact support for further assistance.';
        } else if(isCancelPlanFailure) {
            return 'Your plan cancellation has failed, Please contact support for further assistance.';
        }
    }

return <> 
    <div className="modal fade show modal-center" tabindex="-1">
        <div className="modal-dialog modal-sm">
        <div className="modal-content">
            <div className="modal-body">
                <div className="d-flex flex-column p-2 align-items-center text-center">
                    <i className='icon icon-close icon-2x failure-check mb-2'></i>
                    <label className="form-label text-dark medium mb-2">{getFailedsMessage()}</label>
                    <div className="text-center">
                        <button className="btn btn-failure" onClick={onOk} >OK</button>
                    </div>
                </div>                    
            </div>
        </div>
        </div>
    </div>
    <div className="modal-backdrop fade show"></div>
</>

}
export default PaymentFailed;